'use client';

import Link from 'next/link';

import {
  ListTypeLabel,
// eslint-disable-next-line @stylistic/max-len
} from '@/app/(routes)/listing/_components/page-content/search-list/car-card/listing-type-label';
import { joinSgcmSite } from '@/utils/url/join/public';

import {
  PriceInfoTable,
// eslint-disable-next-line @stylistic/max-len
} from '../../../../_components/page-content/submodel-list/mobile/submodel-info-table/price-info';
import styles from './styles.module.scss';
import type { Component } from './types';

export const SubModels: Component = ({
  carDetailData,
  onOpenSubModelModal,
}) => {
  const availableItems = carDetailData.subModels.filter(
    item => item.isAvailable === true,
  );

  const handleViewFullPriceHistory = (id: number) => {
    onOpenSubModelModal?.(id);
  };

  return (
    <main>
      <div className={styles.containerSubModels}>
        { availableItems.slice()
          .sort((a, b) => {
            if (a.price === null && b.price !== null) return -1;
            if (a.price !== null && b.price === null) return 1;
            return (a.price ?? 0) - (b.price ?? 0);
          })
          .map(subModel => (
            <div
              key={subModel.id}
              className={styles.containerSubModel}>
              <div className={styles.containerTitle}>
                <div className={styles.textSubModelName}>
                  {subModel.name}
                  {subModel.isFacelift && (
                    <ListTypeLabel
                      labelSize={10}
                      type="facelift" />
                  )}
                </div>
                <Link
                  className={styles.textLink}
                  href={`${joinSgcmSite(`/resources/new-car-loan-calculator?car_code=${carDetailData.id}&sub_code=${subModel.id}`)}`}>
                  View Loan Breakdown
                </Link>
              </div>
              <PriceInfoTable
                isPiModel={false}
                submodel={subModel}
                submodelFullName={`${subModel.name}(${subModel.transmissionType})`} />
              <button
                className={styles.btnViewFullPrice}
                onClick={() => handleViewFullPriceHistory(subModel.id)}>
                View full price history
              </button>
            </div>
          ))}
      </div>
    </main>
  );
};
